import { Dispatch, ReactNode, SetStateAction, useCallback, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { IconButton, Menu, MenuItem } from "@mui/material"
import { faEllipsis } from "@fortawesome/pro-solid-svg-icons"
import { DialogContent, Grid, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    addButton: {
        background: "#2196F3",
    },
    dialogContent: {},
}))

interface ActionMenuItem {
    text: string
    onClick: (item: any) => void
}

interface ActionMenuProps {
    item: any
    menuItems: ActionMenuItem[]
}

export const ActionMenu = ({ item, menuItems }: ActionMenuProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <Grid container justifyContent="center">
            <IconButton
                aria-label="more"
                aria-controls={`long-test-${item.id}`}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FontAwesomeIcon size="2xs" icon={faEllipsis} />
            </IconButton>
            {anchorEl && (
                <Menu
                    id={`long-test-${item.id}`}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {menuItems.map((menuItem, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                menuItem.onClick(item)
                                handleClose()
                            }}
                        >
                            {menuItem.text}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </Grid>
    )
}

type AddButtonProps = Readonly<{
    title: string
    setDialogState: Dispatch<SetStateAction<boolean>>
}>

export const AddButton = ({ title, setDialogState }: AddButtonProps) => {
    const { classes } = useStyles()
    const handleAddClick = useCallback(() => {
        setDialogState((prev) => !prev)
    }, [setDialogState])
    return (
        <Grid>
            <StandardButton onClick={handleAddClick} fullWidth={false} color="primary" className={classes.addButton}>
                {title}
            </StandardButton>
        </Grid>
    )
}

type DialogProps = Readonly<{
    dialogState: boolean
    setDialogState: Dispatch<SetStateAction<boolean>>
    title: string
    children: ReactNode
}>

export const SelectionDialog = ({ dialogState, setDialogState, title, children }: DialogProps) => {
    const { classes } = useStyles()
    const handleClose = useCallback(() => {
        setDialogState((prev) => !prev)
    }, [setDialogState])

    return (
        <StandardDialog dialogTitle={title} open={dialogState} onClose={handleClose} maxWidthProp="sm" scroll="body">
            <DialogContent className={classes.dialogContent}>{children}</DialogContent>
        </StandardDialog>
    )
}
